import '@shoelace-style/shoelace/dist/components/spinner/spinner.js';

let overlayCount = 0;

function showOverlay(message = 'Processing...') {
  overlayCount++;
  let overlay = document.getElementById('dynamic-overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.id = 'dynamic-overlay';
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100vw';
    overlay.style.height = '100vh';
    overlay.style.background = 'transparent';
    overlay.style.display = 'flex';
    overlay.style.alignItems = 'center';
    overlay.style.justifyContent = 'center';
    overlay.style.zIndex = '9999';
    overlay.innerHTML = `
      <div style="
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 2rem;
        background: white;
        box-shadow: 0 4px 24px rgba(0,0,0,0.18), 0 1.5px 6px rgba(0,0,0,0.12);
        border-radius: 16px;
        padding: 2.5rem 3rem;
        min-width: 220px;
        min-height: 180px;
      ">
        <sl-spinner style="--track-width: 8px; font-size: 100px; color: #444;"></sl-spinner>
        <div style="color:#222;font-size:2rem;text-align:center">${message}</div>
      </div>
    `;
    document.body.appendChild(overlay);
  }
}

function hideOverlay() {
  overlayCount = Math.max(0, overlayCount - 1);
  if (overlayCount === 0) {
    const overlay = document.getElementById('dynamic-overlay');
    if (overlay) overlay.remove();
  }
}

// Usage pattern
export async function doEventWithOverlay<T>(
  apiCall: (() => Promise<T>) | Promise<T>
) {
  showOverlay();
  try {
    if (typeof apiCall === 'function') {
      return await apiCall();
    } else {
      return await apiCall;
    }
  } finally {
    hideOverlay();
  }
}
